import { useQuery } from '@apollo/client';
import {
  Challenge,
  GET_OPEN_CHALLENGE_ENGAGEMENT,
} from '@frontend/data-access';
import { formatNumber } from '@frontend/shared/util';
import { Card } from 'antd';
import useTranslation from 'next-translate/useTranslation';

/* eslint-disable-next-line */
export interface ChallengeDashboardOpenStatsProps {
  challenge: Challenge & { __typename?: string };
}

export function ChallengeDashboardOpenStats({
  challenge,
}: ChallengeDashboardOpenStatsProps) {
  const { t } = useTranslation('common');
  const { data } = useQuery<{
    openChallengeEngagement: { companies: number; applications: number };
  }>(GET_OPEN_CHALLENGE_ENGAGEMENT, {
    fetchPolicy: 'no-cache',
    variables: {
      challengeId: challenge.id,
    },
  });

  return (
    <Card style={{ borderRadius: 20 }}>
      <div className="grid grid-cols-2 divide-x gap-4 text-gray-900">
        <div>
          <div className="text-base font-normal mb-2">
            {t('institutions_engaged')}
          </div>
          <span className="text-xl font-medium mb-1">
            {formatNumber(data?.openChallengeEngagement?.companies)}
          </span>
        </div>
        <div>
          <div className="text-base font-normal mb-2 ml-6">
            {t('applications')}
          </div>
          <span className="text-xl font-medium mb-1 ml-6">
            {formatNumber(data?.openChallengeEngagement?.applications)}
          </span>
        </div>
      </div>
    </Card>
  );
}

export default ChallengeDashboardOpenStats;
